import { render, staticRenderFns } from "./wenzhenDetail.vue?vue&type=template&id=4029d3c4&scoped=true&"
import script from "./wenzhenDetail.vue?vue&type=script&lang=js&"
export * from "./wenzhenDetail.vue?vue&type=script&lang=js&"
import style0 from "./wenzhenDetail.vue?vue&type=style&index=0&id=4029d3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029d3c4",
  null
  
)

export default component.exports